import styled from 'styled-components';

export const Divider = styled.div`
	height: 1px;
	background-color: ${({ theme }) => theme.v2.color.neutral[400]};
`;
